export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.config.errorHandler = (err: unknown, instance: ComponentPublicInstance | null, info: string) => {
        if (err instanceof Error && err.message.includes('Warning: Setting the NODE_TLS_REJECT_UNAUTHORIZED')) {
            return;
        }
        if (err instanceof Error && err.message.includes('undefined is not an object')) {
            return;
        }
        console.warn('ERROR: ', err, info);
    };

    nuxtApp.vueApp.config.warnHandler = (msg: string, instance: ComponentPublicInstance | null, trace: string) => {
        if (msg.includes('Two component files resolving to the same name UiLinkList')) {
            return;
        }
        console.warn('WARN: ', msg, trace);
    };
});
